import { render, staticRenderFns } from "./BulkCommandsView.vue?vue&type=template&id=099c1473&"
import script from "./BulkCommandsView.vue?vue&type=script&lang=js&"
export * from "./BulkCommandsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports